import React from 'react';
import { Link } from 'react-router-dom';

const PRODUCT_LINKS = [
  { label: 'Search Cards', to: '/series' },
  { label: 'Collection Tracker', to: '/login' },
  { label: 'Price History', to: '/series' },
  { label: 'Canadian Card Stores', to: '/stores' },   // WO-42: hub pages linked from every page
];

const COMPANY_LINKS = [
  { label: 'About', to: '/about' },
  { label: 'How Prices Work', to: '/methodology' },
  { label: 'Contact', to: '/contact' },
  { label: 'Privacy Policy', to: '/privacy' },
];

export default function AppFooter() {
  return (
    <footer className="border-t border-purple/20 bg-[#0d0f1a] pb-10 pt-12 font-landing-sans text-text-primary">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-12 grid grid-cols-2 gap-10 md:grid-cols-4">
          <div className="col-span-2">
            <Link to="/" className="mb-4 inline-flex items-center">
              <img src="/logo.png" alt="Lilycove Logo" className="h-11 w-auto" />
            </Link>
            <p className="max-w-sm text-text-secondary">
              The aggregator for Pokemon card collectors. Find better deals across marketplaces in one search.
            </p>
          </div>

          <div>
            <h4 className="mb-6 font-bold text-text-primary">Product</h4>
            <ul className="space-y-4 text-text-secondary">
              {PRODUCT_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="transition-colors hover:text-brand-hi">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-6 font-bold text-text-primary">Company</h4>
            <ul className="space-y-4 text-text-secondary">
              {COMPANY_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="transition-colors hover:text-brand-hi">
                    {item.label}
                  </Link>
                </li>
              ))}
              {/* WO-35: moved here from the top bar (founder); opens the same reporter as the help button. */}
              <li>
                <button
                  type="button"
                  data-testid="footer-report-bug"
                  onClick={() => window.dispatchEvent(new Event('lilycove:open-feedback'))}
                  className="transition-colors hover:text-brand-hi"
                >
                  Report a bug
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between border-t border-border-base pt-8 text-sm text-text-dim md:flex-row">
          <p>{`© ${new Date().getFullYear()} Lilycove. All rights reserved.`}</p>
          <p className="mt-4 md:mt-0">Not affiliated with Nintendo or The Pokemon Company.</p>
        </div>
        {/* WO-30: Magic card images come from Scryfall under the Wizards of the Coast Fan Content Policy, whose
            notice is required wording (company.wizards.com/en/legal/fancontentpolicy). */}
        <p className="mt-4 text-xs leading-relaxed text-text-dim" data-testid="fan-content-notice">
          Lilycove is unofficial Fan Content permitted under the Fan Content Policy. Not approved/endorsed by Wizards.
          Portions of the materials used are property of Wizards of the Coast. ©Wizards of the Coast LLC. Magic: The
          Gathering card images from Scryfall. Yu-Gi-Oh! card images via YGOPRODeck, © Konami. Card names, images
          and trademarks belong to their owners; Lilycove is not affiliated with Konami, Wizards of the Coast,
          Ravensburger, Bandai or Fantasy Flight Games.
        </p>
      </div>
    </footer>
  );
}
